import { createRouter, createWebHashHistory } from "vue-router";
import HelloWorld from "../components/HelloWorld.vue";
import PrivacyComponent from "../components/PrivacyComponent.vue";
import UserComponent from "../components/UserComponent.vue";

const routes = [
    { path: "/", name: "HelloWorld", component: HelloWorld },
    { path: "/privacy", name: "Privacy", component: PrivacyComponent },
    { path: "/user", name: "User", component: UserComponent },
    { path: "/privacy2", component: ()=> import('@/views/privacy/indexView.vue')}
];

const router = createRouter({
    history: createWebHashHistory('/agreement/'),
    routes,
});

export default router;
